// Live countdown to the next 25 December in the visitor's local time.
class ChristmasCountdown extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const now = new Date();
    const year = now.getMonth() === 11 && now.getDate() > 25 ? now.getFullYear() + 1 : now.getFullYear();
    const target = new Date(year, 11, 25, 0, 0, 0);
    const diff = target.getTime() - now.getTime();
    const output = this.querySelector('[data-countdown-output]');
    if (!output) return;

    if (diff <= 0) {
      output.textContent = this.dataset.merry || '';
      window.clearInterval(this.#timer);
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    const pad = (n) => String(n).padStart(2, '0');
    const { days: d = 'd', hours: h = 'h', minutes: m = 'm', seconds: s = 's' } = this.dataset;
    output.textContent = `${days}${d} ${pad(hours)}${h} ${pad(minutes)}${m} ${pad(seconds)}${s}`;
  }
}

if (!customElements.get('s-christmas-countdown')) {
  customElements.define('s-christmas-countdown', ChristmasCountdown);
}
